/*
 * Mapeo garantia
 */

export const garantiaLimite = "50.000.000";

/**
 * Mapeo de códigos de paquetes
 */
export const codigoPaquete = {
  TARJETA_SUELTA: "00",
  LIBRETON_EXPRESS: "09",
  LIBRETON_FULL: "07",
  LIBRETON_PLUS_GOLD: "01",
  LIBRETON_PREMIUM: "08",
  LIBRETON_PREMIUM_WORLD: "04",
};

/**
 * Mapeo de nombres de paquetes
 * (usado para píxeles)
 */
export const nombresPaquetes = (paquete) => {
  switch (paquete) {
    case codigoPaquete.LIBRETON_EXPRESS:
      return "Libreton Express";
    case codigoPaquete.LIBRETON_PLUS_GOLD:
      return "Libreton Plus Gold";
    case codigoPaquete.LIBRETON_FULL:
      return "Libreton Full";
    case codigoPaquete.LIBRETON_PREMIUM:
      return "Premium";
    case codigoPaquete.LIBRETON_PREMIUM_WORLD:
      return "Premium World";
    default:
      return "";
  }
};

/**
 * Mapeo de códigos de tarjetas
 */
export const codigosTarjetas = {
  VISA_INTERNACIONAL: "CI",
  VISA_GOLD: "PP",
  VISA_PLATINUM: "LL",
  VISA_SIGNATURE: "SS",
  MASTERCARD_GOLD: "13",
  MASTERCARD_PLATINUM: "18",
  MASTERCARD_BLACK: "43",
};

/**
 * Mapeo de nombres de tarjetas
 */
export const nombresTarjetas = {
  VISA_INTERNACIONAL: "Visa Internacional",
  VISA_GOLD: "Visa Gold",
  VISA_PLATINUM: "Visa Platinum",
  VISA_SIGNATURE: "Visa Signature",
  MASTERCARD_GOLD: "Mastercard Gold",
  MASTERCARD_PLATINUM: "Mastercard Platinum",
  MASTERCARD_BLACK: "Mastercard Black",
};

/**
 * Mapeo de códigos de tarjetas VISA
 */
export const codigoTarjetaVisa = {
  INTER: "CI",
  GOLD: "PP",
};
